/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../../components/Context/GloablContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import FilterBtn from './Filter';
import moment from 'moment'
import PatientListExport from '../WellnessExport';
import CustomDatePicker from '../../../../components/DatePicker';
import { convertDatesToEpochUTC } from '../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat';
import dayjs from 'dayjs';
import HelpGuideModal from '../../../../components/HelpGuideModal'
import {useGetHelpGuideProviderQuery} from '../../../../slices/patientSlice'
import { handleSidebarPrvState } from '../../../../redux/systemConfigSlice';

const TopBarPatient = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExport,
    setConfirmationState,data,exportPatient,isIdexport,isFilterOrganization,selectedOrganizationName,setSelectedOrganizationName,TotalCount}) => {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar, setIsSideBar, setIsSearchOpen, isSearchOpen} = useContext(GlobalContext);
    const navigate=useNavigate()
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [dateError, setdateError] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows.selectedIds)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const ref = useRef()
    const ref2 = useRef()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    

    function generateArray(params, object) {
        const result = {};
        if(searchParams?.get('organization_name')===null){
            setSelectedOrganizationName([{
                organization_name:'',
                organization_id:''
            }])
        }
       
        const keysToCheck = ['start_date', 'end_date', 'organization_name'];
        for (const key of keysToCheck) {
            if (params[key] && key !== 'start_date' && key !== 'end_date') {
                const values = params[key].split(',');
                if (key === 'organization_name') {
                    // Assuming filtervals is an object containing organization_id and organization_name
                    result[key] = filtervals['organization_name']; // Use organization_name instead of organization_id
                    result['organization_name'] = filtervals['organization_name'];
                } else {
                    result[key] = values;
                }
            } else if (Object.keys(filtervals).length !== 0 && object?.hasOwnProperty(key) && params[key]) {
                result[key] = filtervals[key];
            }
        }
        return result;
    }

    const handleCheck=(start_date,end_date)=>{
        if((dayjs(end_date).isBefore(dayjs(start_date)))&&(end_date!==undefined&&start_date!==undefined)){
            return true
        }
        return false
    }

    const handleOpenFilter = () => {
        setdateError(false)
        const params = getSearchParams()
        const resultArray = generateArray(params, filterValues);
        setSelectedOrganizationName([{
            organization_name:resultArray?.organization_name,
            organization_id:resultArray?.organization_id
        }])
        // setFilterValues(resultArray)
        // //dispatch(handleAddFilterValues(resultArray))
        setIsFilterOpen(!isFilterOpen)
    }
    
    function handleSelectDate(id,date,dateString,termkey){
        isFilterOpen&&setIsFilterOpen(false)
        if(id==="filter_end_date"&&filterValues?.start_date!==undefined&&handleCheck(filterValues?.start_date,dateString)){
            setdateError(true)
            return
        }
        if(id==="filter_start_date"&&filterValues?.end_date!==undefined&&handleCheck(dateString,filterValues?.end_date)){
            setdateError(true)
            return
        }

        setdateError(false)
        let params = Object.fromEntries(searchParams)
        params.page_number = 1
        params.last_id = null
        params.last_page = null
        if(id==="filter_start_date"){
            setFilterValues((prv) => ({
                ...prv,
                start_date: dateString,
            }));
            
            params.start_date =convertDatesToEpochUTC(moment(dateString).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true)
            setSearchParams({...params})
            
        }
        else{
            setFilterValues((prv) => ({
                ...prv,
                end_date: dateString,
            }));
            params.end_date= convertDatesToEpochUTC(moment(dateString).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false)
            setSearchParams({...params})
        }
    }

    function getSearchParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const result = {};

        searchParams.forEach((value, key) => {
            result[key] = value;
        });

        return result;
    }
    useEffect(() => {
        if (userType === 'monitor-user') {
            setQueryParamsorg('type=monitor-wellness-reports');
        } else {
            setQueryParamsorg('type=provider-wellness-report');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    const handleSearchClick = () => {
        dispatch(handleSidebarPrvState(isSideBar));
        setIsSearchOpen(true);
        setIsSideBar(false);
    };
 
    return (
        <div className="flex justify-between items-center mb-[14px]">
            <div className='flex items-center min-w-fit'>
                <h1 className="text-xl mx-auto font-normal text-[#000000] min-w-max mr-2">{title}</h1>
                <span   onClick={() => setHelpGuideModel(true)} className='mr-2 cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            </div>
            <div className="xl:items-center w-full xl:justify-end items-end relative flex xl:flex-row flex-col">
                <div className={`flex ${isSideBar?'justify-end, 2xl:pb-0 pb-2':'justify-between pb-0'} relative`}>
                    <span className='absolute top-[43px] left-[9px]'>
                        {dateError &&<p className="text-xs text-red-500 mt-2 mr-8">Please select the valid date range.</p>}
                    </span>
                    <div className={`${isSideBar? 'w-[170px] pb-0': 'w-auto 2xl:pb-0 pb-2'} px-2 `}>
                        <div className='w-full'>
                            <CustomDatePicker 
                                id={"filter_start_date"}
                                classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                format="MMM DD, YYYY"
                                state={filterValues}
                                placeholder={"Select start date"}
                                termkey={filterValues?.start_date}
                                handleSelect={handleSelectDate}
                                imageClass={true}
                                setdateError={setdateError}
                            />
                        </div>
                    </div>
                    <div className={`${isSideBar? 'w-[170px] pb-0': 'w-auto 2xl:pb-0 pb-2'} px-2 `}>
                        <div className='w-full'>
                            <CustomDatePicker 
                                classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                placeholder={"Select end date"}
                                format="MMM DD, YYYY"
                                state={filterValues}
                                termkey={filterValues?.end_date}
                                handleSelect={handleSelectDate}
                                id={"filter_end_date"}
                                setdateError={setdateError}
                            />
                        </div>
                    </div>
                </div>
                <div className='flex items-start xl:justify-start justify-end xl:pr-0 pr-2 xl:pt-0 pt-2 ml-0 2xl:pb-0 pb-2'>
                    <button
                        id='search-btn'
                        type='button'
                        onClick={() => handleSearchClick()}
                        className="ml-2 border border-[#972E4C] rounded-[15px] px-[11px] py-[12px] min-w-max">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" />
                    </button>
                    <FilterBtn
                        dateError={dateError}
                        setdateError={setdateError}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        handleApplyFilter={handleApplyFilter}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        initialState={initialState}
                        handleOpenFilter={handleOpenFilter} 
                        selectedOrganizationName={selectedOrganizationName}
                        setSelectedOrganizationName={setSelectedOrganizationName}
                        isPatientSearch={true}
                    />
                    {(SearchInput||isExport)&&data!==undefined&&data?.data?.length>0&& <PatientListExport 
                        selectedRows={selectedRows}
                        exportPatient={exportPatient}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} 
                        username={username} 
                        TotalCount={TotalCount}
                    />
                    }
                    {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                    }
                </div>
            </div>
        </div>
    );
}

export default TopBarPatient;

